import { ReduxState } from "@dashboard/types/reduxState";
import { Supplier } from "@dashboard/types/supplier";

export type SupplierReducerAction = {
  type: "FETCHED_SUPPLIERS";
  payload: Supplier[];
};

export const supplierReducer: (
  state: ReduxState["supplier"] | undefined,
  action: SupplierReducerAction
) => ReduxState["supplier"] = (
  state: ReduxState["supplier"] = {
    initialSuppliersLoading: true,
    suppliers: [],
  },
  action: SupplierReducerAction
) => {
  switch (action.type) {
    case "FETCHED_SUPPLIERS":
      return {
        ...state,
        suppliers: action.payload,
        initialSuppliersLoading: false,
      };
    default:
      return state;
  }
};
